import styled from 'styled-components';
export const ModalWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 36px 0 63px 51px;
  width: 724px;
  background: #ffffff;
  box-shadow: 0px 102px 105px -38px rgba(0, 0, 0, 0.25);
  //overflow: hidden;
`;
// new styles
export const ModalWrapperNew = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 48px 0;
  max-width: 668px;
  max-height: calc(100vh - 200px);
  overflow: auto;

  &::-webkit-scrollbar {
    width: 0px !important;
  }
`;
